import { render, staticRenderFns } from "./ViberForm.vue?vue&type=template&id=3652a9b0&scoped=true"
import script from "./ViberForm.vue?vue&type=script&lang=js"
export * from "./ViberForm.vue?vue&type=script&lang=js"
import style0 from "./ViberForm.vue?vue&type=style&index=0&id=3652a9b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652a9b0",
  null
  
)

export default component.exports